import { TApplicationState } from 'shared/common/types/redux';
import { TRegion } from 'shared/common/types/regions';

export const selectRegions = (state: TApplicationState): TRegion[] => {
  return state.regions;
};
